<template>
  <div class="page-wrapper admin-stats-sheet admin-stats-sheet--cols-4">
    <div class="stats-row">
      <div class="mini-stat" v-for="s in apptStats" :key="s.label">
        <div class="mini-stat-icon" :style="{ background: s.bg, color: s.color }">
          <component :is="s.icon" />
        </div>
        <div>
          <p class="mini-stat-val">{{ s.value }}</p>
          <p class="mini-stat-label">{{ s.label }}</p>
        </div>
      </div>
    </div>

    <div class="page-toolbar admin-list-toolbar appointment-toolbar">
      <div class="page-toolbar-left">
        <div class="filter-tabs">
          <button v-for="tab in tabs" :key="tab.v" class="filter-tab" :class="{ active: activeTab === tab.v }"
            @click="activeTab = tab.v">{{ tab.l }}</button>
        </div>
      </div>
      <div class="page-toolbar-right">
        <div class="view-toggle">
          <button type="button" class="view-btn" :class="{ active: viewMode === 'grid' }" @click="setViewMode('grid')"><el-icon><Grid /></el-icon></button>
          <button type="button" class="view-btn" :class="{ active: viewMode === 'list' }" @click="setViewMode('list')"><el-icon><List /></el-icon></button>
        </div>
        <button v-if="isMember || isAdmin" type="button" class="btn-primary" @click="openAdd">
          <el-icon><Plus /></el-icon>
          <span>{{ isMember ? '我要预约' : '新增预约' }}</span>
        </button>
      </div>
    </div>

    <div class="appt-results-shell">
      <template v-if="viewMode === 'grid'">
        <div class="appt-grid-wrap">
        <div v-if="appointments.length === 0" class="appt-grid-empty">暂无预约数据</div>
        <div v-else class="appt-grid">
          <div class="appt-card" v-for="row in appointments" :key="row.appointmentId">
            <div class="appt-card-top">
              <p class="appt-card-course">{{ row.course }}</p>
              <span class="tag" :class="statusClass(row.status)">{{ row.status }}</span>
            </div>
            <p v-if="isCoach && row.rawStatus === 1 && row.confirmedBy === 'admin'" class="sync-hint">管理员已确认，请按预约时间授课</p>
            <div class="appt-card-body">
              <div v-if="!isMember" class="appt-card-row appt-card-member">
                <span class="meta-label">会员</span>
                <div class="member-cell">
                  <div class="avatar" :class="{ 'avatar--img': !!row.avatarUrl }" :style="row.avatarUrl ? {} : { background: row.avatarBg }">
                    <img v-if="row.avatarUrl" :src="row.avatarUrl" alt="" />
                    <span v-else>{{ (row.member || '?').charAt(0) }}</span>
                  </div>
                  <span class="member-name">{{ row.member }}</span>
                </div>
              </div>
              <div class="appt-card-row">
                <span class="meta-label">教练</span>
                <span class="meta-value">{{ row.coach }}</span>
              </div>
              <div class="appt-card-row">
                <span class="meta-label">预约时间</span>
                <span class="meta-value">{{ row.date }} {{ row.time }}</span>
              </div>
              <div v-if="row.statusRemark || row.confirmedBy === 'admin'" class="appt-card-row">
                <span class="meta-label">说明</span>
                <span class="remark-text">{{ row.statusRemark || '管理员已确认' }}</span>
              </div>
            </div>
            <div class="appt-card-actions action-btns action-btns--wrap">
              <template v-if="isCoach">
                <el-button v-if="row.rawStatus === 0" type="success" size="small" @click="confirmAppt(row)">同意</el-button>
                <el-button v-if="row.rawStatus === 0" type="danger" size="small" plain @click="openReasonDialog(row, 'reject')">拒绝</el-button>
                <el-button v-if="row.rawStatus === 1" type="success" size="small" @click="completeAppt(row)">完成</el-button>
                <el-button v-if="row.rawStatus === 1" type="warning" size="small" @click="openReasonDialog(row, 'coachCancel')">取消预约</el-button>
                <el-button v-if="row.rawStatus === 3 && row.reviewed" type="primary" size="small" plain @click="openViewReviewDialog(row)">查看评价</el-button>
              </template>
              <template v-else-if="isAdmin">
                <button v-if="row.rawStatus === 0" class="act-btn confirm" title="确认" @click="confirmAppt(row)"><el-icon><Check /></el-icon></button>
                <el-button v-if="row.rawStatus === 1" type="success" size="small" @click="completeAppt(row)">完成</el-button>
                <button class="act-btn edit" title="编辑" @click="editAppt(row)"><el-icon><Edit /></el-icon></button>
                <button class="act-btn del" title="取消" @click="cancelApptAdmin(row)"><el-icon><Close /></el-icon></button>
                <button
                  class="act-btn trash"
                  title="删除"
                  :disabled="deletingAppointmentId === row.appointmentId"
                  @click="deleteApptAdmin(row)"
                ><el-icon><Delete /></el-icon></button>
                <el-button v-if="row.rawStatus === 3 && row.reviewed" type="primary" size="small" plain @click="openViewReviewDialog(row)">查看评价</el-button>
              </template>
              <template v-else>
                <el-button v-if="row.rawStatus === 0" type="danger" size="small" plain @click="cancelMemberOwn(row)">取消预约</el-button>
                <el-button v-if="row.rawStatus === 3 && !row.reviewed" type="primary" size="small" @click="openReviewDialog(row)">评价</el-button>
                <el-button v-if="row.rawStatus === 3 && row.reviewed" type="primary" size="small" plain @click="openViewReviewDialog(row)">查看评价</el-button>
              </template>
            </div>
          </div>
        </div>
        </div>
      </template>
      <template v-else>
        <div class="table-card appt-table-shell">
          <el-table :data="appointments" style="width:100%" :header-cell-style="headerStyle">
            <el-table-column type="index" label="#" width="55" />
            <el-table-column v-if="!isMember" label="会员" min-width="130">
              <template #default="{ row }">
                <div class="member-cell">
                  <div class="avatar" :class="{ 'avatar--img': !!row.avatarUrl }" :style="row.avatarUrl ? {} : { background: row.avatarBg }">
                    <img v-if="row.avatarUrl" :src="row.avatarUrl" alt="" />
                    <span v-else>{{ (row.member || '?').charAt(0) }}</span>
                  </div>
                  <span class="member-name">{{ row.member }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="course" label="课程" width="140" />
            <el-table-column prop="coach" label="教练" width="100" />
            <el-table-column prop="date" label="预约日期" width="118" />
            <el-table-column prop="time" label="时间" width="86" />
            <el-table-column label="状态" width="100">
              <template #default="{ row }">
                <span class="tag" :class="statusClass(row.status)">{{ row.status }}</span>
              </template>
            </el-table-column>
            <el-table-column label="说明" min-width="140">
              <template #default="{ row }">
                <span v-if="row.statusRemark" class="remark-text">{{ row.statusRemark }}</span>
                <span v-else class="text-muted">—</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" :width="isCoach ? 260 : isAdmin ? 260 : 160" fixed="right">
              <template #default="{ row }">
                <div class="action-btns action-btns--wrap">
                  <template v-if="isCoach">
                    <el-button v-if="row.rawStatus === 0" type="success" size="small" @click="confirmAppt(row)">同意</el-button>
                    <el-button v-if="row.rawStatus === 0" type="danger" size="small" plain @click="openReasonDialog(row, 'reject')">拒绝</el-button>
                    <el-button v-if="row.rawStatus === 1" type="success" size="small" @click="completeAppt(row)">完成</el-button>
                    <el-button v-if="row.rawStatus === 1" type="warning" size="small" @click="openReasonDialog(row, 'coachCancel')">取消预约</el-button>
                    <el-button v-if="row.rawStatus === 3 && row.reviewed" type="primary" size="small" plain @click="openViewReviewDialog(row)">查看评价</el-button>
                  </template>
                  <template v-else-if="isAdmin">
                    <button v-if="row.rawStatus === 0" class="act-btn confirm" title="确认" @click="confirmAppt(row)"><el-icon><Check /></el-icon></button>
                    <el-button v-if="row.rawStatus === 1" type="success" size="small" @click="completeAppt(row)">完成</el-button>
                    <button class="act-btn edit" title="编辑" @click="editAppt(row)"><el-icon><Edit /></el-icon></button>
                    <button class="act-btn del" title="取消" @click="cancelApptAdmin(row)"><el-icon><Close /></el-icon></button>
                    <button
                      class="act-btn trash"
                      title="删除"
                      :disabled="deletingAppointmentId === row.appointmentId"
                      @click="deleteApptAdmin(row)"
                    ><el-icon><Delete /></el-icon></button>
                    <el-button v-if="row.rawStatus === 3 && row.reviewed" type="primary" size="small" plain @click="openViewReviewDialog(row)">查看评价</el-button>
                  </template>
                  <template v-else>
                    <el-button v-if="row.rawStatus === 0" type="danger" size="small" plain @click="cancelMemberOwn(row)">取消预约</el-button>
                    <el-button v-if="row.rawStatus === 3 && !row.reviewed" type="primary" size="small" @click="openReviewDialog(row)">评价</el-button>
                    <el-button v-if="row.rawStatus === 3 && row.reviewed" type="primary" size="small" plain @click="openViewReviewDialog(row)">查看评价</el-button>
                  </template>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
      <div class="table-footer">
        <span class="total-count">共 {{ total }} 条</span>
        <el-pagination v-model:current-page="currentPage" :page-size="pageSize" :total="total"
          layout="prev, pager, next" background small />
      </div>
    </div>

    <!-- 新建 / 编辑（管理员全字段；会员仅课程+教练+时间） -->
    <el-dialog v-model="showDialog" :title="dialogTitle" width="520px" destroy-on-close>
      <el-form :model="form" label-width="90px">
        <el-form-item v-if="isAdmin" label="会员">
          <el-select v-model="form.memberId" style="width:100%" placeholder="请选择会员">
            <el-option v-for="m in members" :key="m.memberId" :label="m.name || m.username" :value="m.memberId" />
          </el-select>
        </el-form-item>
        <el-form-item label="课程">
          <el-select v-model="form.courseId" style="width:100%" placeholder="请选择课程" @change="onCourseChange">
            <el-option v-for="c in courses" :key="c.courseId" :label="c.name" :value="c.courseId" />
          </el-select>
        </el-form-item>
        <el-form-item label="教练">
          <el-select v-model="form.coachId" style="width:100%" placeholder="请选择教练" :disabled="isMember && !!courseCoachId">
            <el-option v-for="c in coachesForForm" :key="c.coachId" :label="c.name" :value="c.coachId" />
          </el-select>
          <p v-if="isMember && courseCoachId" class="field-hint">该课程已绑定教练，已自动选择</p>
        </el-form-item>
        <el-form-item label="预约日期">
          <div class="appt-schedule">
            <div class="date-quick-list">
              <button
                v-for="d in appointmentDateOptions"
                :key="d.value"
                type="button"
                class="date-quick-btn"
                :class="{ active: form.appointmentDate === d.value }"
                @click="form.appointmentDate = d.value"
              >
                <span class="dq-label">{{ d.label }}</span>
                <span class="dq-sub">{{ d.sub }}</span>
              </button>
            </div>
            <el-date-picker
              v-model="form.appointmentDate"
              type="date"
              class="appt-date-more"
              value-format="YYYY-MM-DD"
              placeholder="更多日期"
              :disabled-date="disabledPastDate"
            />
          </div>
        </el-form-item>
        <el-form-item label="预约时段">
          <el-time-select
            v-model="form.appointmentTimeSlot"
            class="appt-time-select"
            start="08:00"
            step="01:00"
            end="21:00"
            placeholder="请选择整点时段（每节1小时）"
          />
          <p class="field-hint">每节课时长 1 小时，仅可选整点；同一课程同一时段最多 3 人预约</p>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <button class="btn-secondary" @click="showDialog = false">关闭</button>
          <button class="btn-primary" @click="saveAppt">保存</button>
        </div>
      </template>
    </el-dialog>

    <!-- 教练拒绝 / 取消理由 -->
    <el-dialog v-model="reasonDialogVisible" :title="reasonDialogTitle" width="440px" destroy-on-close @closed="reasonText = ''">
      <el-input v-model="reasonText" type="textarea" :rows="4" placeholder="请填写理由，会员端可见" maxlength="500" show-word-limit />
      <template #footer>
        <el-button @click="reasonDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitReason">确定</el-button>
      </template>
    </el-dialog>

    <!-- 查看已提交的评价 -->
    <el-dialog v-model="viewReviewDialogVisible" title="课程评价详情" width="480px" destroy-on-close>
      <p v-if="viewReviewTarget" class="review-target">{{ viewReviewTarget.course }} · {{ viewReviewTarget.coach }} · {{ viewReviewTarget.date }} {{ viewReviewTarget.time }}</p>
      <div v-if="viewReviewTarget" class="view-review-body">
        <div class="view-review-block">
          <p class="view-review-label">课程评分</p>
          <p class="view-review-score">{{ viewReviewTarget.courseRating }} / 10</p>
          <p v-if="viewReviewTarget.courseComment" class="view-review-comment">{{ viewReviewTarget.courseComment }}</p>
          <p v-else class="view-review-empty">暂无课程文字评价</p>
        </div>
        <div class="view-review-block">
          <p class="view-review-label">教练评分</p>
          <p class="view-review-score">{{ viewReviewTarget.coachRating }} / 10</p>
          <p v-if="viewReviewTarget.coachComment" class="view-review-comment">{{ viewReviewTarget.coachComment }}</p>
          <p v-else class="view-review-empty">暂无教练文字评价</p>
        </div>
        <p v-if="viewReviewTarget.reviewTime" class="view-review-time">评价时间：{{ viewReviewTarget.reviewTime }}</p>
      </div>
      <template #footer>
        <el-button type="primary" @click="viewReviewDialogVisible = false">关闭</el-button>
      </template>
    </el-dialog>

    <!-- 会员评价已完成课程 -->
    <el-dialog v-model="reviewDialogVisible" title="课程评价" width="480px" destroy-on-close @closed="resetReviewForm">
      <p v-if="reviewTarget" class="review-target">{{ reviewTarget.course }} · {{ reviewTarget.coach }} · {{ reviewTarget.date }} {{ reviewTarget.time }}</p>
      <el-form label-width="90px">
        <el-form-item label="课程评分">
          <el-input-number v-model="reviewForm.courseRating" :min="0" :max="10" :step="1" />
          <span class="field-hint inline-hint">0-10 分</span>
        </el-form-item>
        <el-form-item label="课程评价">
          <el-input v-model="reviewForm.courseComment" type="textarea" :rows="3" maxlength="500" show-word-limit placeholder="写下对课程的感受（选填）" />
        </el-form-item>
        <el-form-item label="教练评分">
          <el-input-number v-model="reviewForm.coachRating" :min="0" :max="10" :step="1" />
          <span class="field-hint inline-hint">0-10 分</span>
        </el-form-item>
        <el-form-item label="教练评价">
          <el-input v-model="reviewForm.coachComment" type="textarea" :rows="3" maxlength="500" show-word-limit placeholder="写下对教练的评价（选填）" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="reviewDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="reviewSubmitting" @click="submitReview">提交评价</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { Plus, Edit, Check, Close, Delete, Grid, List, Calendar, UserFilled, Stopwatch, TrendCharts } from '@element-plus/icons-vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import api from '@/api/request';
import { resolveMediaUrl } from '@/utils/media';
import adminListViewModeMixin from '@/mixins/adminListViewMode';

const statusMap = { 0: '待确认', 1: '已确认', 2: '已取消', 3: '已完成', 4: '已拒绝' };
const colors = ['#0062FF', '#10B981', '#EF4444', '#F59E0B', '#8B5CF6', '#06B6D4', '#EC4899'];

export default {
  name: 'AppointmentView',
  mixins: [adminListViewModeMixin],
  components: { Plus, Edit, Check, Close, Delete, Grid, List, Calendar, UserFilled, Stopwatch, TrendCharts },
  data() {
    return {
      activeTab: 'all',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      showDialog: false,
      editing: false,
      form: {
        memberId: null,
        courseId: null,
        coachId: null,
        appointmentDate: '',
        appointmentTimeSlot: '',
      },
      members: [],
      courses: [],
      coaches: [],
      tabs: [
        { l: '全部', v: 'all' },
        { l: '待确认', v: '0' },
        { l: '已确认', v: '1' },
        { l: '已取消', v: '2' },
        { l: '已完成', v: '3' },
        { l: '已拒绝', v: '4' },
      ],
      apptStats: [
        { label: '待确认', value: '-', icon: 'Stopwatch', bg: 'rgba(245,158,11,0.1)', color: '#F59E0B' },
        { label: '已确认', value: '-', icon: 'UserFilled', bg: 'rgba(16,185,129,0.1)', color: '#10B981' },
        { label: '已取消', value: '-', icon: 'Close', bg: 'rgba(239,68,68,0.1)', color: '#EF4444' },
        { label: '总预约数', value: '-', icon: 'TrendCharts', bg: 'rgba(139,92,246,0.1)', color: '#8B5CF6' },
      ],
      appointments: [],
      reasonDialogVisible: false,
      reasonText: '',
      reasonMode: 'reject',
      reasonTargetRow: null,
      deletingAppointmentId: null,
      reviewDialogVisible: false,
      viewReviewDialogVisible: false,
      viewReviewTarget: null,
      reviewSubmitting: false,
      reviewTarget: null,
      reviewForm: {
        courseRating: 8,
        courseComment: '',
        coachRating: 8,
        coachComment: '',
      },
    };
  },
  computed: {
    userRole() {
      return this.$store.getters.userRole;
    },
    isAdmin() {
      return this.userRole === 'admin';
    },
    isCoach() {
      return this.userRole === 'coach';
    },
    isMember() {
      return this.userRole === 'member';
    },
    headerStyle() {
      return { background: 'var(--bg-gray)', color: 'var(--text-secondary)', fontSize: '13px', fontWeight: '600' };
    },
    dialogTitle() {
      if (this.isMember) return '预约课程';
      return this.editing ? '编辑预约' : '新增预约';
    },
    courseCoachId() {
      if (!this.form.courseId) return null;
      const c = this.courses.find((x) => x.courseId === this.form.courseId);
      return c && c.coachId != null ? c.coachId : null;
    },
    coachesForForm() {
      if (this.isMember && this.courseCoachId) {
        return this.coaches.filter((co) => co.coachId === this.courseCoachId);
      }
      return this.coaches;
    },
    reasonDialogTitle() {
      return this.reasonMode === 'reject' ? '拒绝预约' : '取消预约';
    },
    appointmentDateOptions() {
      const weekNames = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
      const options = [];
      for (let i = 0; i < 5; i += 1) {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        d.setDate(d.getDate() + i);
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        let label = weekNames[d.getDay()];
        if (i === 0) label = '今天';
        else if (i === 1) label = '明天';
        else if (i === 2) label = '后天';
        options.push({
          value: `${y}-${m}-${day}`,
          label,
          sub: `${m}-${day}`,
        });
      }
      return options;
    },
  },
  mounted() {
    this.loadAppointments();
    this.loadDropdowns();
    this.loadApptStats();
    window.addEventListener('gym-refresh-appointments', this.onExternalRefresh);
  },
  beforeUnmount() {
    window.removeEventListener('gym-refresh-appointments', this.onExternalRefresh);
  },
  watch: {
    activeTab() {
      this.currentPage = 1;
      this.loadAppointments();
    },
    currentPage() {
      this.loadAppointments();
    },
  },
  methods: {
    onExternalRefresh() {
      this.loadAppointments();
      this.loadApptStats();
    },
    async loadApptStats() {
      try {
        const res = await api.getAppointmentStats();
        if (res.data && res.data.code === 200) {
          const d = res.data.data || {};
          this.apptStats[0].value = String(d.pending ?? '-');
          this.apptStats[1].value = String(d.confirmed ?? '-');
          this.apptStats[2].value = String(d.cancelled ?? '-');
          this.apptStats[3].value = String(d.total ?? '-');
        }
      } catch (e) {}
    },
    async loadDropdowns() {
      if (!this.isMember && !this.isAdmin) return;
      try {
        const [mRes, cRes, coRes] = await Promise.all([
          this.isAdmin ? api.getMemberList() : Promise.resolve({ data: {} }),
          api.getCourseList(),
          api.getCoachList(),
        ]);
        if (mRes.data?.code === 200) this.members = mRes.data.data || [];
        if (cRes.data?.code === 200) this.courses = cRes.data.data || [];
        if (coRes.data?.code === 200) this.coaches = coRes.data.data || [];
      } catch (e) {}
    },
    onCourseChange() {
      if (this.isMember && this.courseCoachId) {
        this.form.coachId = this.courseCoachId;
      }
    },
    disabledPastDate(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date.getTime() < today.getTime();
    },
    defaultAppointmentDate() {
      return this.appointmentDateOptions[0]?.value || '';
    },
    splitAppointmentTime(timeStr) {
      if (!timeStr) {
        return { date: this.defaultAppointmentDate(), slot: '' };
      }
      const normalized = String(timeStr).replace(' ', 'T');
      const date = normalized.substring(0, 10);
      const slot = normalized.substring(11, 16);
      return { date, slot };
    },
    buildAppointmentTime() {
      if (!this.form.appointmentDate || !this.form.appointmentTimeSlot) return '';
      return `${this.form.appointmentDate}T${this.form.appointmentTimeSlot}:00`;
    },
    openAdd() {
      this.editing = false;
      this.form = {
        memberId: null,
        courseId: null,
        coachId: null,
        appointmentDate: this.defaultAppointmentDate(),
        appointmentTimeSlot: '',
      };
      this.showDialog = true;
    },
    async loadAppointments() {
      try {
        const params = { pageNumber: this.currentPage, pageSize: this.pageSize };
        if (this.activeTab !== 'all') params.status = this.activeTab;
        const res = await api.getAppointmentPage(params);
        if (res.data && res.data.code === 200) {
          const page = res.data.data;
          const list = page.records || [];
          this.appointments = list.map((a) => {
            const rawAv = a.memberAvatar != null ? String(a.memberAvatar).trim() : '';
            const avatarUrl = rawAv ? resolveMediaUrl(rawAv) : '';
            return {
              ...a,
              member: a.memberName || `会员${a.memberId}`,
              course: a.courseName || `课程${a.courseId}`,
              coach: a.coachName || `教练${a.coachId}`,
              date: a.appointmentTime ? String(a.appointmentTime).substring(0, 10) : '-',
              time: a.appointmentTime ? String(a.appointmentTime).substring(11, 16) : '-',
              rawStatus: a.status,
              reviewed: !!a.reviewed,
              courseRating: a.courseRating,
              courseComment: a.courseComment,
              coachRating: a.coachRating,
              coachComment: a.coachComment,
              reviewTime: a.reviewTime,
              status: statusMap[a.status] != null ? statusMap[a.status] : '未知',
              statusRemark: a.statusRemark || '',
              confirmedBy: a.confirmedBy || '',
              avatarBg: colors[(a.memberId || 0) % colors.length],
              avatarUrl,
            };
          });
          this.total = page.totalRow || 0;
          this.apptStats[3].value = String(this.total);
        }
      } catch (e) {}
    },
    statusClass(s) {
      if (s === '已确认') return 'tag-active';
      if (s === '待确认') return 'tag-warning';
      if (s === '已拒绝') return 'tag-reject';
      if (s === '已完成') return 'tag-done';
      return 'tag-cancel';
    },
    openViewReviewDialog(row) {
      this.viewReviewTarget = row;
      this.viewReviewDialogVisible = true;
    },
    openReviewDialog(row) {
      this.reviewTarget = row;
      this.reviewForm = {
        courseRating: 8,
        courseComment: '',
        coachRating: 8,
        coachComment: '',
      };
      this.reviewDialogVisible = true;
    },
    resetReviewForm() {
      this.reviewTarget = null;
      this.reviewForm = {
        courseRating: 8,
        courseComment: '',
        coachRating: 8,
        coachComment: '',
      };
    },
    async submitReview() {
      if (!this.reviewTarget?.appointmentId) return;
      if (this.reviewForm.courseRating == null || this.reviewForm.coachRating == null) {
        ElMessage.warning('请为课程和教练打分');
        return;
      }
      this.reviewSubmitting = true;
      try {
        const res = await api.submitMemberReview({
          appointmentId: this.reviewTarget.appointmentId,
          courseRating: this.reviewForm.courseRating,
          courseComment: this.reviewForm.courseComment,
          coachRating: this.reviewForm.coachRating,
          coachComment: this.reviewForm.coachComment,
        });
        if (res.data?.code === 200) {
          ElMessage.success('评价已提交');
          this.reviewDialogVisible = false;
          this.loadAppointments();
        } else {
          ElMessage.error(res.data?.message || '提交失败');
        }
      } catch {
        ElMessage.error('提交失败');
      } finally {
        this.reviewSubmitting = false;
      }
    },
    async completeAppt(row) {
      try {
        await ElMessageBox.confirm('确认将该预约标记为已完成？完成后会员可进行评价。', '提示', { type: 'info' });
        const res = await api.completeAppointment(row.appointmentId);
        if (res.data?.code === 200) {
          ElMessage.success('已标记为完成');
          this.loadAppointments();
        } else {
          ElMessage.error(res.data?.message || '操作失败');
        }
      } catch (e) {
        if (e !== 'cancel') ElMessage.error('操作失败');
      }
    },
    async confirmAppt(row) {
      try {
        const res = await api.confirmAppointment(row.appointmentId);
        if (res.data?.code === 200) {
          const msg = this.isAdmin
            ? '已确认，状态已同步至教练与会员'
            : '已同意预约';
          ElMessage.success(msg);
          this.loadAppointments();
          this.loadApptStats();
          window.dispatchEvent(new Event('gym-refresh-notices'));
          window.dispatchEvent(new Event('gym-refresh-appointments'));
        } else {
          ElMessage.error(res.data?.message || '操作失败');
        }
      } catch (e) {
        ElMessage.error('操作失败');
      }
    },
    openReasonDialog(row, mode) {
      this.reasonTargetRow = row;
      this.reasonMode = mode;
      this.reasonText = '';
      this.reasonDialogVisible = true;
    },
    async submitReason() {
      const t = (this.reasonText || '').trim();
      if (!t) {
        ElMessage.warning('请填写理由');
        return;
      }
      const row = this.reasonTargetRow;
      if (!row) return;
      try {
        let res;
        if (this.reasonMode === 'reject') {
          res = await api.coachRejectAppointment(row.appointmentId, t);
        } else {
          res = await api.coachCancelAppointment(row.appointmentId, t);
        }
        if (res.data?.code === 200) {
          ElMessage.success(this.reasonMode === 'reject' ? '已拒绝该预约' : '已取消预约');
          this.reasonDialogVisible = false;
          this.loadAppointments();
        } else {
          ElMessage.error(res.data?.message || '操作失败');
        }
      } catch (e) {
        ElMessage.error('操作失败');
      }
    },
    editAppt(row) {
      this.editing = true;
      const timeStr = row.appointmentTime
        ? String(row.appointmentTime).replace(' ', 'T').substring(0, 19)
        : '';
      const { date, slot } = this.splitAppointmentTime(timeStr);
      this.form = {
        appointmentId: row.appointmentId,
        memberId: row.memberId,
        courseId: row.courseId,
        coachId: row.coachId,
        appointmentDate: date,
        appointmentTimeSlot: slot,
      };
      this.showDialog = true;
    },
    async cancelApptAdmin(row) {
      try {
        await ElMessageBox.confirm('确定取消该预约？', '提示', { type: 'warning' });
        const res = await api.cancelAppointment(row.appointmentId);
        if (res.data?.code === 200) {
          ElMessage.success('已取消');
          this.loadAppointments();
          this.loadApptStats();
        } else {
          ElMessage.error(res.data?.message || '失败');
        }
      } catch (e) {
        if (e !== 'cancel') ElMessage.error('操作失败');
      }
    },
    async deleteApptAdmin(row) {
      if (!row?.appointmentId) return;
      try {
        await ElMessageBox.confirm(
          '将永久删除该条预约记录，且无法恢复。若曾有关联评价等数据，可能产生孤立引用。是否继续？',
          '删除预约',
          { type: 'warning', confirmButtonText: '删除', cancelButtonText: '取消' },
        );
      } catch {
        return;
      }
      this.deletingAppointmentId = row.appointmentId;
      try {
        const res = await api.removeAppointment(row.appointmentId);
        if (res.data?.code === 200) {
          ElMessage.success('已删除');
          this.loadAppointments();
          this.loadApptStats();
        } else {
          ElMessage.error(res.data?.message || '删除失败');
        }
      } catch (e) {
        ElMessage.error('删除失败');
      } finally {
        this.deletingAppointmentId = null;
      }
    },
    async cancelMemberOwn(row) {
      try {
        await ElMessageBox.confirm('确定取消该预约申请？', '提示', { type: 'warning' });
        const res = await api.cancelAppointment(row.appointmentId);
        if (res.data?.code === 200) {
          ElMessage.success('已取消');
          this.loadAppointments();
        } else {
          ElMessage.error(res.data?.message || '失败');
        }
      } catch (e) {
        if (e !== 'cancel') ElMessage.error('操作失败');
      }
    },
    async saveAppt() {
      try {
        const appointmentTime = this.buildAppointmentTime();
        if (this.isMember) {
          if (!this.form.courseId || !this.form.coachId || !appointmentTime) {
            ElMessage.warning('请选择课程、教练、日期与时段');
            return;
          }
          const res = await api.createMemberAppointment({
            courseId: this.form.courseId,
            coachId: this.form.coachId,
            appointmentTime,
          });
          if (res.data?.code === 200) {
            ElMessage.success('预约已提交，请等待教练确认');
            this.showDialog = false;
            this.loadAppointments();
          } else {
            ElMessage.error(res.data?.message || '提交失败');
          }
          return;
        }
        const form = {
          ...this.form,
          appointmentTime,
        };
        delete form.appointmentDate;
        delete form.appointmentTimeSlot;
        if (!form.memberId || !form.courseId || !form.coachId || !form.appointmentTime) {
          ElMessage.warning('请填写完整');
          return;
        }
        let res;
        if (this.editing && form.appointmentId) {
          res = await api.updateAppointment(form);
        } else {
          delete form.appointmentId;
          res = await api.saveAppointment(form);
        }
        if (res.data?.code === 200) {
          ElMessage.success('保存成功');
          this.showDialog = false;
          this.loadAppointments();
        } else {
          ElMessage.error(res.data?.message || '保存失败');
        }
      } catch (e) {
        ElMessage.error('保存失败');
      }
    },
  },
};
</script>

<style scoped>
.page-wrapper { padding: 0; background: var(--bg-base); min-height: 100vh; }
.mini-stat { background: var(--bg-white); border: 1px solid var(--border-color); border-radius: var(--radius-lg); padding: 16px 20px; display: flex; align-items: center; gap: 14px; transition: all 0.3s; }
.mini-stat:hover { transform: translateY(-2px); box-shadow: var(--shadow-lg); }
.mini-stat-icon { width: 44px; height: 44px; border-radius: var(--radius-md); display: flex; align-items: center; justify-content: center; font-size: 20px; flex-shrink: 0; }
.mini-stat-val { font-size: 22px; font-weight: 700; color: var(--text-primary); margin: 0 0 2px; font-family: 'Inter', sans-serif; }
.mini-stat-label { font-size: 12px; color: var(--text-muted); margin: 0; }

.view-toggle { display: flex; gap: 4px; }
.view-btn {
  width: 32px; height: 32px; display: flex; align-items: center; justify-content: center;
  border: 1px solid var(--border-color); background: var(--bg-white); color: var(--text-muted);
  border-radius: var(--radius-sm); cursor: pointer; transition: all 0.3s;
}
.view-btn.active { background: rgba(0, 98, 255, 0.1); color: var(--primary-blue); border-color: var(--primary-blue); }

.appt-results-shell {
  display: flex;
  flex-direction: column;
  gap: 0;
  background: var(--bg-white);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  overflow: hidden;
  min-width: 0;
}
.appt-results-shell .appt-table-shell {
  border: none;
  border-radius: 0;
}
.appt-grid-wrap {
  padding: 20px;
  min-width: 0;
  box-sizing: border-box;
}
.appt-grid-empty {
  text-align: center;
  padding: 48px 16px;
  font-size: 14px;
  color: var(--text-muted);
}
.appt-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  min-width: 0;
}
.appt-card {
  background: var(--bg-white);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: all 0.3s;
}
.appt-card:hover { transform: translateY(-2px); box-shadow: var(--shadow-lg); border-color: var(--primary-blue); }
.appt-card-top { display: flex; align-items: flex-start; justify-content: space-between; gap: 10px; }
.appt-card-course { font-size: 15px; font-weight: 700; color: var(--text-primary); margin: 0; flex: 1; line-height: 1.3; }
.sync-hint {
  margin: -4px 0 0;
  font-size: 12px;
  color: var(--primary-blue);
  line-height: 1.4;
}
.appt-card-body { display: flex; flex-direction: column; gap: 8px; flex: 1; }
.appt-card-row { display: flex; align-items: center; gap: 10px; font-size: 13px; }
.appt-card-member .member-cell { flex: 1; min-width: 0; }
.meta-label { font-size: 12px; color: var(--text-muted); flex-shrink: 0; width: 56px; }
.meta-value { font-size: 13px; color: var(--text-primary); font-weight: 500; }
.appt-card-actions { margin-top: auto; padding-top: 8px; border-top: 1px solid var(--border-color); }

.table-card { background: var(--bg-white); border: 1px solid var(--border-color); border-radius: var(--radius-lg); overflow: hidden; }

.filter-tabs { display: flex; gap: 6px; flex-wrap: wrap; }
.filter-tab {
  padding: 5px 14px;
  border: 1px solid var(--border-color);
  background: var(--bg-gray);
  color: var(--text-secondary);
  border-radius: var(--radius-sm);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
  flex-shrink: 0;
}
.filter-tab:hover { border-color: var(--primary-blue); color: var(--primary-blue); }
.filter-tab.active { background: var(--primary-blue); border-color: var(--primary-blue); color: white; }

/* 窄屏：换行排布，不改变按钮内容宽度比例 */
@media (max-width: 768px) {
  .appointment-toolbar .page-toolbar-left {
    width: 100%;
    min-width: 0;
  }

  .appointment-toolbar .filter-tabs {
    display: flex !important;
    flex-wrap: wrap !important;
    width: 100%;
    min-width: 0;
    overflow-x: visible !important;
    gap: 6px;
  }

  .appointment-toolbar .filter-tab {
    flex: 0 0 auto;
    padding: 6px 12px;
  }

  .appt-results-shell {
    border-radius: var(--radius-md);
  }

  .appt-grid-wrap {
    padding: 12px;
  }

  .appt-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .table-footer {
    flex-direction: column;
    align-items: stretch;
    padding: 12px 14px;
  }

  .table-footer :deep(.el-pagination) {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    row-gap: 8px;
    width: 100%;
  }
}

.btn-primary { display: inline-flex; align-items: center; gap: 6px; padding: 0 18px; height: 38px; background: var(--gradient-primary); color: white; border: none; border-radius: var(--radius-md); font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.3s; }
.btn-primary:hover { transform: translateY(-1px); box-shadow: var(--shadow-glow); }
.btn-secondary { display: inline-flex; align-items: center; gap: 6px; padding: 0 18px; height: 38px; background: var(--bg-gray); color: var(--text-primary); border: 1px solid var(--border-color); border-radius: var(--radius-md); font-size: 14px; cursor: pointer; transition: all 0.3s; }
.btn-secondary:hover { border-color: var(--primary-blue); color: var(--primary-blue); }

.member-cell { display: flex; align-items: center; gap: 8px; }
.avatar { width: 32px; height: 32px; border-radius: var(--radius-sm); display: flex; align-items: center; justify-content: center; color: white; font-weight: 700; font-size: 13px; flex-shrink: 0; overflow: hidden; }
.avatar.avatar--img { background: transparent; }
.avatar img { width: 100%; height: 100%; object-fit: cover; display: block; }
.member-name { font-size: 13px; font-weight: 600; color: var(--text-primary); }

.tag { display: inline-block; padding: 3px 10px; border-radius: 20px; font-size: 12px; font-weight: 600; flex-shrink: 0; }
.tag-active  { background: rgba(16,185,129,0.1); color: #10B981; }
.tag-warning { background: rgba(245,158,11,0.1); color: #F59E0B; }
.tag-cancel  { background: rgba(107,114,128,0.1); color: #6B7280; }
.tag-done    { background: rgba(0,98,255,0.1); color: #0062FF; }

.view-review-body { display: flex; flex-direction: column; gap: 16px; }
.view-review-block { padding: 12px 14px; background: var(--bg-gray); border-radius: var(--radius-md); }
.view-review-label { font-size: 13px; font-weight: 600; color: var(--text-secondary); margin: 0 0 6px; }
.view-review-score { font-size: 20px; font-weight: 700; color: var(--primary-blue); margin: 0 0 8px; }
.view-review-comment { font-size: 14px; color: var(--text-primary); margin: 0; line-height: 1.5; white-space: pre-wrap; }
.view-review-empty { font-size: 13px; color: var(--text-muted); margin: 0; }
.view-review-time { font-size: 12px; color: var(--text-muted); margin: 0; }
.review-target {
  margin: 0 0 16px;
  font-size: 13px;
  color: var(--text-secondary);
}
.inline-hint {
  margin-left: 8px;
  display: inline;
}
.tag-reject  { background: rgba(239,68,68,0.12); color: #EF4444; }

.remark-text { font-size: 12px; color: var(--text-secondary); line-height: 1.4; word-break: break-word; flex: 1; }
.text-muted { color: var(--text-muted); font-size: 12px; }
.field-hint { margin: 6px 0 0; font-size: 12px; color: var(--text-muted); }

.appt-schedule {
  width: 100%;
}
.date-quick-list {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 4px;
  margin-bottom: 10px;
  -webkit-overflow-scrolling: touch;
}
.date-quick-list::-webkit-scrollbar {
  height: 4px;
}
.date-quick-btn {
  flex: 0 0 auto;
  min-width: 64px;
  padding: 8px 10px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  background: var(--bg-white);
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}
.date-quick-btn:hover {
  border-color: var(--primary-blue);
  color: var(--primary-blue);
}
.date-quick-btn.active {
  border-color: var(--primary-blue);
  background: rgba(0, 98, 255, 0.08);
  color: var(--primary-blue);
}
.dq-label {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
}
.dq-sub {
  font-size: 11px;
  opacity: 0.75;
}
.appt-date-more,
.appt-time-select {
  width: 100%;
}

.action-btns { display: flex; gap: 6px; align-items: center; }
.action-btns--wrap { flex-wrap: wrap; }
.act-btn { width: 28px; height: 28px; border: none; border-radius: var(--radius-sm); display: flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.3s; font-size: 13px; }
.act-btn.confirm { background: rgba(16,185,129,0.1); color: #10B981; }
.act-btn.confirm:hover { background: #10B981; color: white; }
.act-btn.edit { background: rgba(245,158,11,0.1); color: #F59E0B; }
.act-btn.edit:hover { background: #F59E0B; color: white; }
.act-btn.del { background: rgba(239,68,68,0.1); color: #EF4444; }
.act-btn.del:hover { background: #EF4444; color: white; }
.act-btn.trash { background: rgba(107,114,128,0.12); color: #374151; }
.act-btn.trash:hover:not(:disabled) { background: #6B7280; color: white; }
.act-btn:disabled { opacity: 0.45; cursor: not-allowed; }

.table-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid var(--border-color);
}
.total-count { font-size: 13px; color: var(--text-muted); }

.dialog-footer { display: flex; justify-content: flex-end; gap: 10px; }
</style>
